import React, { useState } from "react";
import ModalComponent from "../../../Components/ModalComponent";
import { Button, Col, Form, Input, Row, Select } from "antd";
import type { FormProps } from "antd";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../apis/store";
import { showNotitfication } from "../../../utils/Utils";
import {
  toExchangePoints,
  toGetMyLoyaltyHistory,
  toGetMyWalletHistory,
  toGetProfil,
  ToGetQitafOtp,
  toGetRajhiOtp,
} from "../../../apis/actions/auth.actions";
import { toPrepareWalletTopUp } from "../../../apis/actions/paymentMethods.actions";
import { useTranslation } from "react-i18next";
import qitaf from "../../../styles/images/qitaf.png";
import rajhi from "../../../styles/images/rajhi.png";
import myList from "../../../styles/images/mylist.png";
import mada from "../../../styles/images/mada.svg";
import mc from "../../../styles/images/mc.svg";
import visa from "../../../styles/images/visa.svg";
import loayl from "../../../assets/loyal.png";
import OtpModal from "./OtpModal";
import MyListPayment from "../../../Components/PaymentsAndPoints/MyListPayment";
import yougotagift from "../../../styles/images/yougotagift.png";
import YouGotaGiftPayment from "../../../Components/PaymentsAndPoints/YouGotaGIftPayment";
import HyperPayForm from "../../../Components/PaymentsAndPoints/HyperPayForm";
import MadaForm from "../../../Components/PaymentsAndPoints/HyperPayFormMada";
import { RiWallet3Line } from "react-icons/ri";
import {
  clearPendingWalletTopUp,
  rememberPendingWalletTopUp,
  walletTopUpResultUrl,
  WALLET_TOPUP_BRAND,
} from "../../../utils/walletTopUp";

interface ExchangeProps {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  /** Reserved for future use (e.g. pre-fill points). */
  selectedData?: unknown;
}

type TopUpMethodId =
  | "card"
  | "mada"
  | "points"
  | "qitaf"
  | "rajhi"
  | "mylist"
  | "yougotagift";

/** Methods that charge the customer, so they ask for an amount in SAR. */
type GatewayMethodId = "card" | "mada";

function isGatewayMethod(
  method: TopUpMethodId | undefined
): method is GatewayMethodId {
  return method === "card" || method === "mada";
}

const LoyaltyExchange = ({ showModal, setShowModal }: ExchangeProps) => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [type, setType] = useState("");
  const [otpToken, setOtpToken] = useState("");
  const { t, i18n } = useTranslation();
  const [isListVisible, setIsListVisible] = useState(false);
  const [isGotaGiftVisibility, setIsGotaGiftVisibility] = useState(false);
  const [cardTopUpAmount, setCardTopUpAmount] = useState<number | null>(null);
  const [madaTopUpAmount, setMadaTopUpAmount] = useState<number | null>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [loadingExchange, setLoadingExchange] = useState(false);

  const methodId = Form.useWatch("method", form) as TopUpMethodId | undefined;
  const hasMethodSelected = Boolean(methodId);

  const validateSaudiPhone = (_: unknown, value: string) => {
    const saudiPhoneRegex = /^5[0-9]{8}$/;
    if (!value) {
      return Promise.reject(new Error(t("otp.warning.phone")));
    }
    if (!saudiPhoneRegex.test(value)) {
      return Promise.reject(new Error(t("register.invalidSaudiPhone")));
    }
    return Promise.resolve();
  };

  const validateTopUpAmount = (_: unknown, value: string) => {
    const amount = Number(value);
    if (!value || !Number.isFinite(amount) || amount <= 0) {
      return Promise.reject(new Error(t("otp.warning.amount")));
    }
    return Promise.resolve();
  };

  const handleCloseOtpModal = () => {
    setIsModalVisible(false);
  };

  const handleApply = async () => {
    try {
      await form.validateFields(["method", "points"]);
      setLoadingExchange(true);

      const values = form.getFieldsValue();
      const points = values.points;
      const success = (await dispatch(
        toExchangePoints({ points: parseFloat(String(points)) })
      )) as { payload?: { data?: { result?: { code?: number; message?: string } } } };
      const exchangePoints = success?.payload?.data?.result;
      if (exchangePoints?.code === 200) {
        showNotitfication(exchangePoints?.message ?? "", "success");
        form.resetFields();
        await dispatch(toGetProfil(i18n.language));
        setTimeout(() => {
          setShowModal(false);
        }, 2800);
        dispatch(toGetMyLoyaltyHistory());
        dispatch(toGetMyWalletHistory());
      } else {
        showNotitfication(exchangePoints?.message ?? "", "error");
      }
      setLoadingExchange(false);
    } catch {
      setLoadingExchange(false);
    }
  };

  /**
   * Odoo reserves the top-up first (`topup_id`), then the HyperPay widget charges
   * the amount; the payment result page confirms it against that id.
   */
  const handleGatewayTopUp = async (method: GatewayMethodId) => {
    try {
      await form.validateFields(["method", "topupAmount"]);
    } catch {
      return;
    }

    const amount = Number(form.getFieldValue("topupAmount"));

    setLoadingExchange(true);
    const prepared = (await dispatch(
      toPrepareWalletTopUp({ amount, payment_brand: WALLET_TOPUP_BRAND[method] })
    )) as { payload?: { data?: any } };
    setLoadingExchange(false);

    const data = prepared?.payload?.data;
    const topup = data?.result ?? data;
    if (topup?.code !== 200 || !topup?.topup_id) {
      showNotitfication(topup?.message ?? t("result.failed"), "error");
      return;
    }
    rememberPendingWalletTopUp({ amount, method, topupId: topup.topup_id });

    if (method === "mada") {
      setMadaTopUpAmount(amount);
    } else {
      setCardTopUpAmount(amount);
    }
    setShowModal(false);
  };

  /** Dropping the pending marker keeps an abandoned attempt from crediting later. */
  const handleCloseGatewayTopUp = () => {
    clearPendingWalletTopUp();
    setCardTopUpAmount(null);
    setMadaTopUpAmount(null);
  };

  const handleOtpQitaf = async () => {
    try {
      await form.validateFields(["method", "phone"]);
      setLoadingExchange(true);

      const values = form.getFieldsValue();
      const phone = "966" + values.phone;
      setPhoneNumber(phone);
      const success = (await dispatch(ToGetQitafOtp({ phone: phone }))) as {
        payload?: { data?: { result?: { code?: number; message?: { code?: number } } } };
      };
      const QitafOtp = success?.payload?.data?.result;
      if (QitafOtp?.code === 200) {
        form.resetFields();
        await dispatch(toGetProfil(i18n.language));

        setTimeout(() => {
          setShowModal(false);
        }, 2800);
        setIsModalVisible(true);
      } else if (QitafOtp?.message?.code === 1019) {
        showNotitfication(
          i18n.language === "en"
            ? "Wrong number or customer is not registered in Qitaf program."
            : "الرقم غير صحيح أو العميل غير مشترك في برنامج قطاف",
          "error"
        );
      } else if (QitafOtp?.message?.code === 1014) {
        showNotitfication(
          i18n.language === "en"
            ? "Insufficient balance"
            : "لا يوجد رصيد كاف لإتمام العملية",
          "error"
        );
      } else {
        showNotitfication(
          i18n.language === "en" ? "Invalid Number!" : "الرقم غير صالح!",
          "error"
        );
      }

      setLoadingExchange(false);
    } catch {
      setLoadingExchange(false);
    }
  };

  const handleOtpRajhi = async () => {
    try {
      await form.validateFields(["method", "phone"]);
      setLoadingExchange(true);

      const values = form.getFieldsValue();
      const phone = "966" + values.phone;
      setPhoneNumber(phone);

      const success = (await dispatch(toGetRajhiOtp({ phone }))) as {
        payload?: { data?: { result?: { code?: number; message?: { code?: number }; otp_token?: string } } };
      };
      const RajhiOtp = success?.payload?.data?.result;

      if (RajhiOtp?.code === 200 || RajhiOtp?.message?.code == 210) {
        setOtpToken(RajhiOtp?.otp_token ?? "");
        form.resetFields();
        await dispatch(toGetProfil(i18n.language));

        setTimeout(() => {
          setShowModal(false);
        }, 2800);
        setIsModalVisible(true);
      } else {
        switch (RajhiOtp?.message?.code) {
          case 207:
          case 209:
            showNotitfication(
              i18n.language === "en"
                ? "User does not exist"
                : "العميل غير مشترك في برنامج مكافأة",
              "error"
            );
            break;

          case 205:
            showNotitfication(
              i18n.language === "en"
                ? "This member balance is lower than the minimum points balance required"
                : "حساب العميل أقل من الحد الأدنى",
              "error"
            );
            break;

          default:
            showNotitfication(
              i18n.language === "en" ? "Something went wrong" : "حدث خطأ ما",
              "error"
            );
            break;
        }
      }

      setLoadingExchange(false);
    } catch {
      setLoadingExchange(false);
    }
  };

  const paymentList: { id: TopUpMethodId; icon: React.ReactNode; name: string }[] =
    [
      // ponytail: card + mada top-up hidden for now; the gateway plumbing below still works, re-add these entries to bring them back.
      {
        id: "points",
        icon: <img src={loayl} alt="" width={28} height={28} />,
        name: t("payment.points"),
      },
      {
        id: "qitaf",
        icon: <img src={qitaf} alt="" width={28} height={28} />,
        name: t("payment.qitaf"),
      },
      {
        id: "rajhi",
        icon: <img src={rajhi} alt="" width={28} height={28} />,
        name: t("payment.rajhi"),
      },
      {
        id: "mylist",
        icon: <img src={myList} width={28} height={28} alt="" />,
        name: t("payment.myList"),
      },
      {
        id: "yougotagift",
        icon: <img src={yougotagift} width={28} height={28} alt="" />,
        name: t("payment.yougotaGift"),
      },
    ];

  const paymentOptions = paymentList.map((item) => ({
    label: (
      <div className="ac-wallet-modal__select-option">
        {item.icon}
        <span>{item.name}</span>
      </div>
    ),
    value: item.id,
  }));

  const handleclose = () => {
    setShowModal(false);
    setType("");
    form.resetFields();
  };

  const handleMylist = () => {
    setShowModal(false);

    setIsListVisible(true);
  };
  const handleGotaGift = () => {
    setIsGotaGiftVisibility(true);
    setShowModal(false);
  };

  const isRtl = i18n.language === "ar";

  const submitLabel = isGatewayMethod(methodId)
    ? t("profile.topup_continue")
    : methodId === "qitaf" || methodId === "rajhi"
    ? t("btn.send_otp")
    : t("btn.exchange");

  const onFinish: FormProps["onFinish"] = () => {
    switch (methodId) {
      case "card":
      case "mada":
        void handleGatewayTopUp(methodId);
        break;
      case "qitaf":
        setType("qitaf");
        void handleOtpQitaf();
        break;
      case "rajhi":
        setType("rajhi");
        void handleOtpRajhi();
        break;
      case "mylist":
        setType("mylist");
        handleMylist();
        break;
      case "yougotagift":
        setType("yougotagift");
        handleGotaGift();
        break;
      case "points":
        setType("Autochapeau");
        void handleApply();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <ModalComponent
        title={
          <div className={`ac-wallet-modal__head${isRtl ? " ac-wallet-modal__head--rtl" : ""}`}>
            <div className="ac-wallet-modal__icon ac-wallet-modal__icon--wallet" aria-hidden>
              <RiWallet3Line />
            </div>
            <div className="ac-wallet-modal__head-text">
              <h2 className="ac-wallet-modal__title ac--font-expo">{t("profile.exchange")}</h2>
              <p className="ac-wallet-modal__lead">{t("profile.modal_topup_lead")}</p>
            </div>
          </div>
        }
        open={showModal}
        onClose={handleclose}
        closeOnOutsideClick={true}
        width={520}
        centered
        destroyOnClose
        className="ac-modal-wallet ac-modal-wallet--wide"
        canvasBackdrop
      >
        <div
          className={`ac-wallet-modal__body ac-wallet-modal__body--exchange${isRtl ? " ac-wallet-modal__body--rtl" : ""}`}
          dir={isRtl ? "rtl" : "ltr"}
        >
          <Form
            form={form}
            layout="vertical"
            className="ac-wallet-modal__form"
            onFinish={onFinish}
          >
            <Row gutter={[0, 12]}>
              <Col span={24}>
                <Form.Item
                  label={<span className="ac-wallet-modal__label">{t("profile.pointss")}</span>}
                  name="method"
                  rules={[
                    {
                      required: true,
                      message: t("profile.messages.2"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("profile.messages.1")}
                    options={paymentOptions}
                    className="ac-wallet-modal__select ac--select-points ac--select-wallet-modal"
                    size="large"
                    allowClear
                    onChange={() => {
                      form.setFieldsValue({
                        points: undefined,
                        phone: undefined,
                        topupAmount: undefined,
                      });
                      setType("");
                    }}
                    getPopupContainer={() => document.body}
                    popupClassName="ac-wallet-modal__select-dropdown"
                  />
                </Form.Item>
              </Col>
              {methodId === "points" && (
                <Col span={24}>
                  <Form.Item
                    label={<span className="ac-wallet-modal__label">{t("payment.points")}</span>}
                    name="points"
                    rules={[
                      {
                        required: true,
                        message: t("otp.warning.amount"),
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      className="ac--input-login ac-wallet-modal__input-control ac-wallet-modal__input--amount"
                      size="large"
                      min={0}
                      placeholder="0"
                    />
                  </Form.Item>
                </Col>
              )}
              {isGatewayMethod(methodId) && (
                <Col span={24}>
                  <Form.Item
                    label={
                      <span className="ac-wallet-modal__label">
                        {t("profile.topup_amount")}
                      </span>
                    }
                    name="topupAmount"
                    rules={[{ validator: validateTopUpAmount }]}
                  >
                    <Input
                      type="number"
                      className="ac--input-login ac-wallet-modal__input-control ac-wallet-modal__input--amount"
                      size="large"
                      min={1}
                      placeholder="0"
                      onKeyDown={(e) => {
                        if (["-", ",", "e", "E"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      {...(isRtl
                        ? {
                            addonAfter: (
                              <span
                                className="ac-wallet-modal__prefix-currency icon-saudi_riyal ac-wallet-modal__riyal"
                                aria-hidden
                              />
                            ),
                          }
                        : {
                            addonBefore: (
                              <span
                                className="ac-wallet-modal__prefix-currency icon-saudi_riyal ac-wallet-modal__riyal"
                                aria-hidden
                              />
                            ),
                          })}
                    />
                  </Form.Item>
                </Col>
              )}
              {(methodId === "qitaf" || methodId === "rajhi") && (
                <Col span={24}>
                  <Form.Item
                    label={<span className="ac-wallet-modal__label">{t("profile.account.phone")}</span>}
                    name="phone"
                    rules={[
                      {
                        validator: validateSaudiPhone,
                      },
                    ]}
                  >
                    <Input
                      addonBefore={
                        <span className="ac-wallet-modal__prefix-code">966</span>
                      }
                      placeholder="5XXXXXXXX"
                      type="text"
                      className="ac--input-login ac-wallet-modal__input-control"
                      size="large"
                      maxLength={9}
                      autoComplete="tel-national"
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        form.setFieldsValue({ phone: value });
                      }}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
            {hasMethodSelected ? (
              <div className="ac-wallet-modal__actions">
                <Button
                  className="ac-wallet-modal__submit ac--btn-edit-save"
                  htmlType="submit"
                  type="primary"
                  size="large"
                  block
                  disabled={loadingExchange === true}
                  loading={loadingExchange}
                >
                  {loadingExchange === true ? t("btn.loading") : submitLabel}
                </Button>
              </div>
            ) : null}
          </Form>
        </div>
      </ModalComponent>
      <OtpModal
        open={isModalVisible}
        onClose={handleCloseOtpModal}
        phone={phoneNumber}
        type={type === "qitaf" ? "qitaf" : "rajhi"}
        otp_token={otpToken}
      />
      <MyListPayment
        isOpen={isListVisible}
        setIsOpen={() => setIsListVisible(false)}
      />
      <YouGotaGiftPayment
        isOpen={isGotaGiftVisibility}
        setIsOpen={() => setIsGotaGiftVisibility(false)}
      />
      <HyperPayForm
        isOpen={cardTopUpAmount !== null}
        setIsOpen={handleCloseGatewayTopUp}
        amountOverride={cardTopUpAmount ?? undefined}
        resultUrl={walletTopUpResultUrl("card")}
      />
      <MadaForm
        isOpen={madaTopUpAmount !== null}
        setIsOpen={handleCloseGatewayTopUp}
        amountOverride={madaTopUpAmount ?? undefined}
        resultUrl={walletTopUpResultUrl("mada")}
      />
    </>
  );
};

export default LoyaltyExchange;
